export const GET_COURIER_RATE = Symbol("GET_COURIER_RATE");
export const GET_COURIER_RATE_REQUEST = Symbol("GET_COURIER_RATE_REQUEST");
export const GET_COURIER_RATE_SUCCESS = Symbol("GET_COURIER_RATE_SUCCESS");
export const GET_COURIER_RATE_ERROR = Symbol("GET_COURIER_RATE_ERROR");
export const CHANGE_COURIER_RATE = Symbol("CHANGE_COURIER_RATE");
export const CHANGE_COURIER_RATE_REQUEST = Symbol("CHANGE_COURIER_RATE_REQUEST");
export const CHANGE_COURIER_RATE_SUCCESS = Symbol("CHANGE_COURIER_RATE_SUCCESS");
export const CHANGE_COURIER_RATE_ERROR = Symbol("CHANGE_COURIER_RATE_ERROR");